// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { displayName } from 'conversations-internal-schema/file-metadata/operators/displayName';
import { getSize, getUrl
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-internal-schema/file-metadata/operators/fileMetadataGetters';
import FormattedSize from 'I18n/components/FormattedSize';
import { PureComponent } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../theming/contexts/ThemeContext';
import VizExFileAttachment from 'visitor-ui-component-library/file/VizExFileAttachment';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGFile from 'visitor-ui-component-library-icons/icons/SVGFile';
import { jsx as _jsx } from "react/jsx-runtime";
export const FileAttachmentTileWrapper = styled.div.withConfig({
  displayName: "FileAttachmentTile__FileAttachmentTileWrapper"
})(["max-width:300px;"]);
class FileAttachmentTile extends PureComponent {
  render() {
    const {
      fileMetadata
    } = this.props;
    const name = displayName(fileMetadata);
    const url = getUrl(fileMetadata);
    const size = getSize(fileMetadata);
    return /*#__PURE__*/_jsx(FileAttachmentTileWrapper, {
      "data-test-id": "file-attachment-tile",
      children: /*#__PURE__*/_jsx(VizExFileAttachment, {
        onClick: () => window.open(url),
        fileName: name,
        fileInfo: /*#__PURE__*/_jsx(FormattedSize, {
          value: size
        }),
        preview: /*#__PURE__*/_jsx(VizExIcon, {
          icon: /*#__PURE__*/_jsx(SVGFile, {}),
          size: "sm"
        })
      })
    });
  }
}
FileAttachmentTile.displayName = 'FileAttachmentTile';
FileAttachmentTile.propTypes = {
  fileMetadata: RecordPropType('FileMetadataRecord').isRequired
};
FileAttachmentTile.contextType = ThemeContext;
export default FileAttachmentTile;